// extracted by mini-css-extract-plugin
export default {"info-container":"PageNotFound_info-container__lV9ef"};